
var sw = window.innerWidth;
var sh = window.innerHeight;
var header = document.querySelector("header");
var sticky = 0;

// Font Resizer ------------------- Start
function fontResizer() {
  var perc = parseInt(sw) / 120;
  document.body.style.fontSize = perc + 'px';
}


// Loader ------------------- Start
function pageLoader() {
  // document.querySelector("html").classList.add("loadjs");
  setTimeout(function () {
    if (document.querySelector(".loader-first")) {
      document.querySelector(".loader-first").style.display = "none";
      document.querySelector("html").classList.remove("loadjs");
    }
  }, 1500);
}

// Window on Load ----------------- Start
window.onload = function () {
  pageLoader();
  if (sw > 1199) {
    fontResizer();
  }
};

// Window On Resize ----------------- Start
(function () {
  window.addEventListener('resize', (event) => {
    sw = window.innerWidth;
    sh = window.innerHeight;
    if (sw > 1025) {
      if (sw < 1400 && sw > 1300 && sh > 900) { } else {
        fontResizer();
      }
    }
  });
})();

// Landscape Mode off ---------------- Start
const mql = window.matchMedia("(orientation:landscape)");
mql.addEventListener("change", (event) => {
  if (event.matches) {
    if (innerWidth < 930) {
      // console.log("Now in landscape orientation");
      document.getElementById("portrait-warning").style.display = "flex";
    }
  } else {
    // console.log("Now in portrait orientation");
    document.getElementById("portrait-warning").style.display = "none";
  }
});


// Sticky Header ---------------- Start
(function () {
  if (document.querySelector('.header')) {
    function stickyHeader() {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    }
    window.addEventListener('scroll', (event) => {
      stickyHeader();
    });
  }
})();


// SVG Convert Code
window.addEventListener("load", function () {
  (function () {
    if (document.querySelector(".svg-convert")) {
      let svgs = document.querySelectorAll('img.svg-convert');
      svgs.forEach((el) => {
        const imgID = el.getAttribute('id');
        const imgClass = el.getAttribute('class');
        const imgURL = el.getAttribute('src');

        fetch(imgURL)
          .then((response) => response.text())
          .then(data => {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(data, 'text/html');
            let svg = xmlDoc.querySelector('svg');
            if (typeof imgID !== 'undefined') {
              svg.setAttribute('id', imgID);
            }

            if (typeof imgClass !== 'undefined') {
              svg.setAttribute('class', imgClass + ' svg-converted');
            }

            svg.removeAttribute('xmlns:a');

            el.parentNode.replaceChild(svg, el);
          })
      });
    }
  })();

});

// animate Observer------------Start
(function () {
  if (window.innerWidth > 767) {
    let anim = [...document.querySelectorAll(".animate")];

    let options = {
      rootMargin: "0px",
      threshold: 0.2,
    };

    let animate = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.animation = `anim 1s ${entry.target.dataset.delay} forwards ease-out`;
        }
      });
    };

    let observer = new IntersectionObserver(animate, options);

    anim.forEach((item, idx) => {
      observer.observe(item);
    });
  }
})();


// Lazy Load Img observer
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const imgElements = document.querySelectorAll("img[data-src]");

    const lazyLoadingImage = (entries, observer2) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.src = entry.target.dataset.src;
        entry.target.addEventListener("load", () => {
          entry.target.classList.remove("lazy-img");
          observer2.unobserve(entry.target);
        });
      });
    };
    const lazyLoadingObserver = new IntersectionObserver(lazyLoadingImage, {
      threshold: 0,
      rootMargin: "0px 0px 150px 0px",
    });
    imgElements.forEach((img) => lazyLoadingObserver.observe(img));
  });
})();


// (function () {
//   if (document.querySelector("#toggle")) {
//     let toggleMenu = document.querySelector("#toggle");
//     let htmlEl = document.querySelector("html");

//     toggleMenu.addEventListener("click", (event) => {
//       let _this = event.target;
//       _this.classList.toggle("active");
//       document.querySelector(".navigation").classList.toggle("active");
//       document.querySelector(".navigation").classList.toggle("open");

//       if (!htmlEl.classList.contains("overflow-hidden")) {
//         htmlEl.classList.add("overflow-hidden");
//       }
//     });
//   }
// })();

(function () {
  if (document.querySelector("#toggle")) {
    let toggleMenu = document.querySelector("#toggle");
    let htmlEl = document.querySelector("html");

    toggleMenu.addEventListener("click", (event) => {
      let _this = event.target;
      _this.classList.toggle("active");
      document.querySelector(".navigation").classList.toggle("active");
      document.querySelector(".navigation").classList.toggle("open");

      // Toggle overflow-hidden class on html element
      htmlEl.classList.toggle("overflow-hidden");
    });
  }
})();



document.querySelectorAll('.mobileToggle').forEach(toggle => {
  toggle.addEventListener('click', function () {
    // Remove active class and max-height from all other toggles and menus
    document.querySelectorAll('.mobileToggle').forEach(item => {
      if (item !== this) {
        item.classList.remove('active');
        item.nextElementSibling.style.maxHeight = null;
      }
    });

    // Toggle active class on the clicked toggle
    this.classList.toggle('active');

    // Toggle max-height of the next sibling (inner-menu)
    const innerMenu = this.nextElementSibling;
    if (innerMenu.style.maxHeight) {
      innerMenu.style.maxHeight = null; // Collapse the menu
    } else {
      innerMenu.style.maxHeight = innerMenu.scrollHeight + "px"; // Expand the menu
    }
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const searchWrapper = document.querySelector('.search-wrapper');
  const searchPopup = document.querySelector('.search-popup');
  const crossIcon = document.querySelector('.cross-icon');

  // Check if elements exist before proceeding
  if (searchWrapper && searchPopup && crossIcon) {
    // Open search popup on search-wrapper click
    searchWrapper.addEventListener('click', function () {
      searchPopup.classList.add('open');
    });

    // Close search popup on cross-icon click
    crossIcon.addEventListener('click', function () {
      searchPopup.classList.remove('open');
    });

    // Optional: Close on ESC key press
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        searchPopup.classList.remove('open');
      }
    });
  }
});


if (document.querySelector(".related-newsSlider")) {
  var relatedNewsSlider = new Swiper(".related-newsSlider", {
    slidesPerView: 1,
    watchSlidesProgress: true,
    spaceBetween: 32,
    breakpoints: {
      480: {
        slidesPerView: 3,
        spaceBetween: 32
      },
    }
  });
}



document.querySelectorAll('.toggle-btn').forEach(toggle => {
  toggle.addEventListener('click', function () {
    // Remove active class and max-height from all other toggles and menus
    document.querySelectorAll('.toggle-btn').forEach(item => {
      if (item !== this) {
        item.classList.remove('active');
        item.nextElementSibling.style.maxHeight = null;
      }
    });

    // Toggle active class on the clicked toggle
    this.classList.toggle('active');

    // Toggle max-height of the next sibling (inner-menu)
    const footerMenu = this.nextElementSibling;
    if (footerMenu.style.maxHeight) {
      footerMenu.style.maxHeight = null; // Collapse the menu
    } else {
      footerMenu.style.maxHeight = footerMenu.scrollHeight + "px"; // Expand the menu
    }
  });
});

if (document.querySelector(".dropdownWrapper")) {
  const dropdownWrappers = document.querySelectorAll(".dropdownWrapper");

  dropdownWrappers.forEach(wrapper => {
      const toggleButton = wrapper.querySelector(".dropdown");
      const items = wrapper.querySelectorAll(".items");

      toggleButton.addEventListener("click", () => {
          wrapper.classList.toggle("open");
      });

      items.forEach(item => {
          item.addEventListener("click", () => {
              toggleButton.textContent = item.textContent.trim(); // Set the dropdown text to the item's text
              wrapper.classList.remove("open"); // Close the dropdown
          });
      });
  });
}



(function () {
  const faqContainers = document.querySelectorAll('.faq_container');

  faqContainers.forEach(container => {
      const header = container.querySelector('.faq_header');
      const content = container.querySelector('.faq_content');

      header.addEventListener('click', function () {
          container.classList.toggle('active');

          if (container.classList.contains('active')) {
              content.style.maxHeight = content.scrollHeight + 100 + 'px';
          } else {
              content.style.maxHeight = 0;
          }
      });
  });
})();


(function () {
  document.addEventListener('DOMContentLoaded', function () {
      var inputFile = document.getElementById('cv-upload');
      console.log("inputfile", inputFile)
      if (inputFile) {
          var label = document.querySelector('label[for="cv-upload"]');
          if (label) {
              var defaultLabel = label.querySelector('span').innerHTML;
              console.log("Default label text:", defaultLabel);
              inputFile.addEventListener('change', function (e) {
                  var fileName = '';
                  if (this.files && this.files.length > 0) {
                      fileName = this.files[0].name; 
                  } else {
                  }
                  if (fileName) {
                      label.querySelector('span').innerHTML = fileName; 
                  } else {
                     label.querySelector('span').innerHTML = defaultLabel;
                  }
              });
          } else {

          }
      } else {
          // console.error("Input file element not found.");
      }
  });
})();


if (document.querySelector(".partner-slider")) {
  var partnerSlider = new Swiper(".partner-slider", {
    slidesPerView: 1,
    breakpoints: {
      640: {
          slidesPerView: 2,
          spaceBetween: 20,
      },
      1024: {
          slidesPerView: 3,
          spaceBetween: 20,
      },
      1200: {
          slidesPerView: 5,
          spaceBetween: 20,
      },
  },
    spaceBetween: 10,
    allowTouchMove: true,
    // loop: true,
    watchSlidesProgress: true,
    // speed: 2000,
    // autoplay: {
    //   delay: 10000,
    //   disableOnInteraction: false,
    // },
  });
}

if (document.querySelector(".financial-slider")) {
  var financialSlider = new Swiper(".financial-slider", {
    slidesPerView: 2,
    breakpoints: {
      640: {
          slidesPerView: 3,
          spaceBetween: 20,
      },
      1024: {
          slidesPerView: 4,
          spaceBetween: 20,
      },
      1200: {
          slidesPerView: 4,
          spaceBetween: 20,
      },
  },
    spaceBetween: 30,
    allowTouchMove: true,
    watchSlidesProgress: true,
    // speed: 2000,
    // autoplay: {
    //   delay: 10000,
    //   disableOnInteraction: false,
    // },
  });
}


